import React, { DispatchWithoutAction, FC, useContext } from 'react';
import { Form } from 'react-bootstrap';
import { useSitesCreateForm } from './hooks/useSitesCreateForm';
import { FormProvider } from 'react-hook-form';
import ModalContext from 'react-bootstrap/ModalContext';
import { SiteDto } from './dto/SiteDto';
import { api } from '../functions/api';
import { ApiPath } from '../api/ApiPath';
import { useSaveItem } from '../hooks/useSaveItem';
import { useTranslation } from 'react-i18next';
import { FormModalFooter } from '../components/form/FormModalFooter';
import { ModalHeader } from '../components/form/ModalHeader';
import { SiteFormBody } from './SiteFormBody';

interface Props {
  update: DispatchWithoutAction;
}

export const SitesCreate: FC<Props> = ({ update }) => {
  const { t } = useTranslation();
  const form = useSitesCreateForm();
  const { onHide } = useContext(ModalContext);
  const save = useSaveItem<SiteDto>((data) =>
    api({
      url: ApiPath.Sites,
      method: 'post',
      data,
    }),
  );

  const onSubmit = (data: SiteDto) => {
    save(data).then(() => {
      update();
      onHide();
    });
  };

  return (
    <FormProvider {...form}>
      <Form onSubmit={form.handleSubmit(onSubmit)}>
        <ModalHeader>{t('Add new site')}</ModalHeader>
        <SiteFormBody />
        <FormModalFooter />
      </Form>
    </FormProvider>
  );
};
